import { render, staticRenderFns } from "./AgregarRegla.vue?vue&type=template&id=d93352b6"
import script from "./AgregarRegla.vue?vue&type=script&lang=js"
export * from "./AgregarRegla.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports